import { pGetAllPieceJointe } from '@/api/pieceJointes';
import {
  PIECE_JOINTE_TYPE_LOGO_RELANCE_1,
  PIECE_JOINTE_TYPE_LOGO_RELANCE_2,
  PIECE_JOINTE_TYPE_LOGO_RELANCE_3,
} from '@/configuration/general/pieceJointeConf';
import genererRelance from '@/services/relances/genererRelance';
import moment from 'moment';

export async function checkLogoRelanceByRegleFacturation(relance) {
  const regleFacturationId = relance.regleFacturationId;
  if (regleFacturationId && [1, 2, 3].includes(relance.numRelance)) {
    const type = [
      PIECE_JOINTE_TYPE_LOGO_RELANCE_1,
      PIECE_JOINTE_TYPE_LOGO_RELANCE_2,
      PIECE_JOINTE_TYPE_LOGO_RELANCE_3,
    ][relance.numRelance - 1];
    if (!type) return null;
    const logoFacture = (await pGetAllPieceJointe({
      elementsId: [regleFacturationId],
    })).data.result.items.find(p => p.type.libelle === type);
    return logoFacture ? (logoFacture.cheminMin || logoFacture.chemin) : null;
  }
  return null;
}

function mergeRelanceInfoMouvementClient(echeancesPaiement, listeRelances) {
  listeRelances.forEach((relance) => {
    let mouvementClientResult = echeancesPaiement.filter((el) => {
      return relance.mouvementsClientIds.includes(el.id);
    });
    if (!mouvementClientResult.length) {
      return;
    }
    mouvementClientResult = mouvementClientResult.sort((a, b) => {
      if (a.factureId < b.factureId) return -1;
      if (a.factureId > b.factureId) return 1;
      if (a.factureId === b.factureId) {
        if (moment(a.factureDate)
          .isAfter(moment(b.factureDate))) return 1;
        if (moment(a.factureDate)
          .isSame(moment(b.factureDate))) return 0;
        return -1;
      }
      return -1;
    });
    mouvementClientResult.forEach(mvt => {
      relance.mouvementsClients.push({
        mouvementClientId: mvt.id,
        libelle: mvt.libelle,
        dateEcheance: mvt.dateMouvement,
        montantEcheance: mvt.montantTtc,
        resteAPayer: mvt.resteALettrer,
        facture: {
          id: mvt.factureId,
          code: mvt.factureCode,
          montantTtc: mvt.factureMontantTtc,
          societeId: mvt.societeId,
          agenceId: mvt.factureAgenceId,
          date: mvt.factureDate,
          commandeCode: mvt.commandeCode,
          commandeId: mvt.commandeId,
          commercialId: mvt.factureCommercialId,
        },
      });
    });
  });
  return listeRelances;
}

export function grouperEcheancesSelectionnes(echeancesSelectionnes) {
  const grouperParPayeursEtRegleFacturationId = echeancesSelectionnes
    .reduce((acc, ech) => {
      const groupeId = [ech.payeurId, ech.regleFacturationId]
        .filter(el => el).join('_');
      if (!acc[groupeId]) {
        acc[groupeId] = [ech];
      } else acc[groupeId].push(ech);
      return acc;
    }, {});
  return grouperParPayeursEtRegleFacturationId;
}

export async function generationRelances(echeancesPaiement, isRegrouperParPayeur) {
  const promiseRelances = [];
  if (isRegrouperParPayeur) {
    const grouperParPayeurs = grouperEcheancesSelectionnes(echeancesPaiement);
    Object.values(grouperParPayeurs).forEach(groupe => {
      promiseRelances.push(
        genererRelance(groupe, new Date(), Math.max(...groupe.map((el) => el.numRelance))),
      );
    });
  } else {
    echeancesPaiement.forEach(ech => {
      promiseRelances.push(
        genererRelance([ech], new Date(), ech.numRelance),
      );
    });
  }
  const listeRelances = await Promise.all(promiseRelances);
  mergeRelanceInfoMouvementClient(echeancesPaiement, listeRelances);
  return listeRelances;
}
